import {client} from "@/store";

export class QueuedFile {

	file;
	type;
	companyId;
	fileContent;
	thumbnail;
	state = 'pending';
	progress = 0;
	forceUpdate;
	file_name;
	readyToUpload = false;
	onReadyToUpload;

	constructor(file, type, companyId, forceUpdate) {
		if(typeof file === 'string') {
			this.dataURItoBlob(file);
			this.file_name = type.split('/').pop() + (new Date()).toISOString() +'.jpg';
			this.readyToUpload = true;
		} else {
			this.setFile(file);
			this.file_name = file.name;
		}
		this.type = type;
		this.companyId = companyId;
		this.forceUpdate = forceUpdate;
	}

	get displayName() {
		return this.file.name;
	}


	getThumbnail() {
		return this.thumbnail;
	}

	dataURItoBlob(dataURI) {
		// https://stackoverflow.com/questions/12168909/blob-from-dataurl

		var byteString = atob(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);

		// create a view into the buffer
		var ia = new Uint8Array(ab);

		// set the bytes of the buffer to the correct values
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		this.file = new Blob([ab], {type: mimeString});
	}

	setFile(file) {
		this.onReadyToUpload = new Promise((resolve, reject) => {
			const blobURL = window.URL.createObjectURL(file);
			const img = new Image();
			img.onload = (event) => {
				const height = img.height;
				const width = img.width;

				const {
					newHeight,
					newWidth
				} = this.getNewHeightAndWidth(height, width);
				const canvas = document.createElement('canvas', {id: file.name});
				canvas.width = newWidth;
				canvas.height = newHeight;

				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, newWidth, newHeight);
				canvas.toBlob((blob) => {
					this.file = blob;
					window.URL.revokeObjectURL(file);
					this.thumbnail = window.URL.createObjectURL(blob);
					this.readyToUpload = true;
					resolve();
				}, 'image/jpeg', 0.7);
			}
			img.src = blobURL;
		});
	}

	getNewHeightAndWidth(height, width) {
		if(width < 1500 && height < 1500) {
			return {
				newHeight: height,
				newWidth: width
			}
		}
		if(height > width) {
			const scaleFactor = width / 1500;
			return {
				newHeight: height / scaleFactor,
				newWidth: width / scaleFactor
			}
		} else {
			const scaleFactor = height / 1500;
			return {
				newHeight: height / scaleFactor,
				newWidth: width / scaleFactor
			}
		}
	}

	upload() {
		if(this.readyToUpload === false) {
			return this.onReadyToUpload.then(() => {
				return this.upload();
			});
		}

		return new Promise((resolve, reject) => {
			this.state = 'uploading';
			this.forceUpdate();
			const formData = new FormData();
			formData.append('file', this.file, this.file_name);
			formData.append('file_type', this.type);
			formData.append('company_id', this.companyId);
			const xhr = new XMLHttpRequest();
			xhr.open('POST', '/files/upload');
			xhr.onprogress = (event) => {
				this.progress = event.loaded / event.total * 100;
				this.forceUpdate();
			}
			xhr.onload = () => {
				let parsedResponse = xhr.response;
				if(typeof xhr.response === 'string') {
					parsedResponse = JSON.parse(xhr.response);
				}
				if (xhr.status === 200 && parsedResponse.hasOwnProperty("error") === false) {
					this.state = 'uploaded';
					resolve(xhr.response);
				} else {
					this.state = 'error';
					reject(xhr.response);
					const context = {
						fileType: formData.get('file_type'),
						company_id: formData.get('company_id'),
						fileName: this.file.name,
						fileSize: this.file.size,
						fileMimeType: this.file.type
					}

					client.query(`mutation($error: String $url: String, $context: String) {
        							logError(error: $error, url: $url, context: $context)
					}`, {
						error: xhr.response,
						context: JSON.stringify(context),
						url: '/files/upload',
					}).then(result => {
						if (result.logError !== true) {
							console.error('Error logging failed');
						}
					}).catch(error => {
						console.error('Error logging failed');
					});
				}
			};
			xhr.send(formData);
		});
	}
}
